module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE3AAAhNwEzWJ96AAABBElEQVRoge2ZwRGDIBREl1RiCfHuxRLsIGmAHtKCDSQdmCIoICVYgh2QcQZvQgLCfDLZd2VY9smohw9CjqFyPz+ruzuAi2f5oUZzzXleVoEP5TeySmQT+LL8RjYJr4DV3RnABKDJcdABZgCDGs1rL+IUyK2hPFyHybcYEqih/EZjdbfbJyRQFWo0c6zA7gYhvF1CAkMlErPrQkgJov/EVne25E2o0UR1+pnPqA8KSEMBaSggDQWkoYA0FJCGAtJQQBoKSEMBaSggzV8KLAV6JGenCDwT9hTLThG4FbqFxWVHES3gJiV9Zok1q/dNYUIkvcRuYtiu49KDIovLaH1TSEJKAuAN3z84DKytpNwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/ic_btn_delete@3x.png
// module id = 732
// module chunks = 0